import React from 'react';
import { useQuery } from '@apollo/react-hooks';
import moment from 'moment';

import { EntriesTable } from '../../../components/EntriesTable';
import GET_ENTRIES from '../../../graphql/queries/getEntries';
import GET_PROJECTS from '../../../graphql/queries/getProjects';
import GET_WORKS from '../../../graphql/queries/getWorks';
import GET_DEVICES from '../../../graphql/queries/getDevices';
import { useManipulators } from '../../../hooks/useManipulators';

export const ActivityTab = ({ worker }) => {
  const { data: projectsData = {}, loading: projectsLoading } = useQuery(GET_PROJECTS);
  const { data: worksData = {}, loading: worksLoading } = useQuery(GET_WORKS);
  const { data: devicesData = {}, loading: devicesLoading } = useQuery(GET_DEVICES);

  const { filters, orderBy, manipulator } = useManipulators({
    topBorder: true,
    filters: [
      {
        name: 'start',
        type: 'input',
        default: moment().subtract(2, 'months').startOf('day').format('DD.MM.YYYY'),
        hide: true,
      },
      {
        name: 'end',
        type: 'input',
        default: moment().format('DD.MM.YYYY'),
        hide: true,
      },
      {
        name: 'project',
        type: 'select',
        options: projectsData.projects,
        loading: projectsLoading,
      },
      {
        name: 'worker',
        type: 'select',
        default: worker.id,
        hide: true,
      },
      {
        name: 'work',
        type: 'select',
        options: worksData.works,
        loading: worksLoading,
      },
      {
        name: 'device',
        type: 'select',
        options: devicesData.devices,
        loading: devicesLoading,
      },
    ],
    orderBy: {
      options: [
        { text: 'Start time', value: 'start' },
        { text: 'End time', value: 'end' },
        { text: 'Project', value: 'project'},
        { text: 'Work', value: 'work'},
        { text: 'Devices', value: 'device'},
      ],
    },
  });

  const { data: entriesData = {}, loading: entriesLoading } = useQuery(GET_ENTRIES, {
    fetchPolicy: 'cache-and-network',
    variables: { filters, orderBy },
  });

  return (
    <>
      { manipulator }
      <EntriesTable
        hideWorkers
        entriesLoading={entriesLoading}
        entriesData={entriesData}
      />
    </>
  );
};
